import React from 'react';
import {
  removeItemAtIndex,
  replaceItemAtIndex,
} from '@teetsh/app/src/utils/listMethods';
import Input from '@teetsh/app/src/components/Form/Input2';
import DynamicList, {
  useDynamicListContext,
} from '@teetsh/app/src/components/DynamicList';
import { OldCustomFieldOption } from '@teetsh/app/src/types/oldCustomField';
import { v4 as uuid } from 'uuid';
import { ColorPicker } from '@teetsh/app/src/components/Form/Colorpicker';
import { css } from 'twin.macro';
import { useColorPalette } from 'containers/App/context/useColorPalette';
import { randomBackgroundColor } from 'components/colors';

interface Props {
  onChange: (v: OldCustomFieldOption[]) => void;
  items: OldCustomFieldOption[];
  inline?: boolean;
}

function SimpleInputWithColor(props: {
  onChange: (v: OldCustomFieldOption[]) => void;
  items: OldCustomFieldOption[];
}) {
  const { colorPalette } = useColorPalette();
  const p = useDynamicListContext();
  if (!p) {
    return null;
  }
  const { item, index } = p;
  return (
    <div tw="flex items-center space-x-2">
      <Input
        tw="mb-0 flex-grow"
        id={`item-${index}`}
        onChange={v =>
          props.onChange(
            replaceItemAtIndex(
              props.items,
              {
                ...item,
                value: v?.currentTarget?.value || '',
              },
              index,
            ),
          )
        }
        value={item.value}
      />

      <ColorPicker
        css={[
          // Petite bidouille pour que le button du colorpicker ait la même taille que l'input
          css`
            padding: 18px;
            margin-top: 1px;
          `,
        ]}
        portal={true}
        value={item.color}
        onChange={v =>
          props.onChange(
            replaceItemAtIndex(
              props.items,
              {
                ...item,
                color: v,
              },
              index,
            ),
          )
        }
        colorPalette={colorPalette}
      />
    </div>
  );
}

export function ListInputsWithColors(props: Props) {
  const { items, onChange, inline } = props;
  return (
    <DynamicList<OldCustomFieldOption>
      inline={inline}
      items={items}
      itemKeyFn={e => e.id}
      onRemove={index => onChange(removeItemAtIndex(items, index))}
      onAdd={() =>
        onChange([
          ...items,
          {
            color: randomBackgroundColor(),
            value: '',
            id: uuid(),
          },
        ])
      }
    >
      <SimpleInputWithColor onChange={onChange} items={items} />
    </DynamicList>
  );
}
